import { Component } from '@angular/core';
import { Firestore, collection, query, where, getDocs, addDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'admin-deportes-elite';

  constructor(private firestore: Firestore) {}

  async ngOnInit() {
    try {
      // Verificar si existe el usuario admin
      const usersRef = collection(this.firestore, 'usuarios');
      const q = query(usersRef, 
        where('email', '==', 'adminde'),
        where('password', '==', 'adminpass')
      );
      
      const querySnapshot = await getDocs(q);
      console.log('Verificación de usuario admin:', querySnapshot.empty ? 'No existe' : 'Existe');
      
      if (querySnapshot.empty) {
        // Crear usuario admin si no existe
        console.log('Creando usuario admin...');
        const docRef = await addDoc(usersRef, {
          email: 'adminde',
          password: 'adminpass',
          role: 'admin',
          identificador: '1',
          nombre: 'Administrador',
          createdAt: new Date()
        });
        console.log('Usuario admin creado con ID:', docRef.id);
      }
    } catch (error) {
      console.error('Error al verificar/crear usuario admin:', error);
    }
  }
}